var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 10.9766C15.8672 9.0099 14.7339 7.32101 13.0894 6.49879V8.95434L15.8116 11.6766C15.845 11.4543 15.8672 11.221 15.8672 10.9766ZM18.645 10.9766C18.645 12.021 18.4227 12.9988 18.045 13.9099L19.7227 15.5877C20.4561 14.2099 20.8672 12.6432 20.8672 10.9766C20.8672 6.22101 17.545 2.24323 13.0894 1.24323V3.52101C16.3005 4.47656 18.645 7.45434 18.645 10.9766ZM2.2783 0.976562L0.867188 2.37656L6.11163 7.63212H0.867188V14.2988H5.31163L10.8672 19.8543V12.3766L15.5894 17.0988C14.845 17.6766 14.0116 18.1321 13.0894 18.4099V20.6988C14.6227 20.3543 16.0116 19.6432 17.1894 18.6877L19.4561 20.9655L20.8672 19.5543L10.8672 9.55434L2.28941 0.976562H2.2783ZM10.8561 2.07656L8.53385 4.38767L10.8561 6.7099V2.08767V2.07656Z",
    fill: "#00495F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.67cf414c674044f917b336e61d4c51ab.svg";
export { ForwardRef as ReactComponent };